export default "__VITE_ASSET__D_W2W30f__"